import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./combustiveis.component.html')
})
export class CombustiveisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/combustiveis/combustiveis.component.ts
 **/